/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: clipping.js
 */

SCS.fn = SCS.fn || {};

SCS.fn.clipping = function (context, $) {
	$clippingElements = $('.scs-clipping', context);
	if(!$clippingElements.length) {
		return;
	}

	// Export sdx.Accordion, sdx.Select, and sdx.Modal as global as they are used in the eCommerce checkout process.
	var sdx = window.sdx || {};
	sdx.Accordion = require('sdx/accordion/Accordion').default;
	sdx.Select = require('sdx/form/Select').default;
	sdx.Modal = require('sdx/modal/Modal').default;
	window.sdx = sdx;

	$clippingElements.each(function () {
		var $this = $(this),
			hashParams = window.location.hash.slice(1),
			getParams = window.location.search.slice(1),
			url = $this.data('url'),
			parameters,
			params;

		if (typeof url === "undefined") {
			return;
		}

		params = getParams;

		// Bail on already-initialized clippings
		if ($this.data('scs-clipping-has-been-processed')) {
			debug.log('SCS.fn.clipping > Clipping already initialized', url);
			return;
		}
		$this.data('scs-clipping-has-been-processed', true);

		if (hashParams.length > 0) {
			params = params + '&' + hashParams;
		}

		// trim ampersand at beginning of string
		while (params.charAt(0) === '&') {
			params = params.slice(1);
		}

		if (params.length > 0) {

			// encode for firefox which automatically decodes the Link / URL
			if (params.indexOf(' ') != -1) {
				params = encodeURI(params);
			}

			if (url.indexOf('?') === -1) {
				url = url + '?' + params;
			}
			else {
				// if url-data have params and since they are cached they are wrong.
				url = url.slice(0, url.indexOf('?')).concat('?').concat(params);
			}
		}

		$this.attr('data-url', url);
		$this.load(url, function (response, status, xhr) {
			if (xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
				SCS.ecommerce.showEcommerceErrorMessage();
			} else if (status == 'error') {
				SCS.portal.showError(xhr.statusText + ' (' + xhr.status + ')');
			} else {
				// Mark successful load
				$this.data('scs-clipping-has-been-processed', 1);
			}
		});

		if (url.toLowerCase().indexOf('productid') !== -1) {
			//update other wrong links

			//head link[rel='alternate']
			$('head link[rel="alternate"]').each(function () {
				fixLanguageLinks(this, params);
			});

			// lang links
			$('body ul .scs-pie a').each(function () {
				fixLanguageLinks(this, params);
			});

			var logoutUrl = $('body #scs-pageheader-userbox').data('logout-url');
			if (logoutUrl.indexOf('konfiguration.html') != -1 && logoutUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox'), params, 'data-logout-url', logoutUrl);
			}

			logoutUrl = $('body #scs-pageheader-userbox-logout-button').attr('href');
			if (logoutUrl.indexOf('konfiguration.html') != -1 && logoutUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox-logout-button'), params, 'href', logoutUrl);
			}

			var loginUrl = $('body #scs-pageheader-userbox').data('login-url');
			if (loginUrl.indexOf('konfiguration.html') != -1 && loginUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox'), params, 'data-login-url', loginUrl);
			}
		}


	});

	function fixLanguageLinks(element, params) {
		var localeUrl = $(element).attr('href');
		if (localeUrl.indexOf('?') === -1) {
			localeUrl = localeUrl + '?' + params;
		}
		else {
			// if url-data have params and since they are cached they are wrong.
			localeUrl = localeUrl.slice(0, localeUrl.indexOf('?')).concat('?').concat(params);
		}
		$(element).attr('href', localeUrl);
	}

	function fixLoginAndLogoutButtons(element, params, attributeName, url) {
		var rurl = decodeURIComponent(url.slice(url.indexOf('RURL') + 5)),
			base = rurl.slice(0, rurl.indexOf('?')),
			rurlBase = url.slice(0, url.indexOf('RURL') + 5);

		element.attr(attributeName, rurlBase + encodeURIComponent(base.concat('?').concat(params)));
	}

};

SCS.ensure(SCS.fn.clipping, 'body, .ui-tabs-panel');





//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/clipping.js
// module id = 247
// module chunks = 0